import styled from "styled-components";
export const PointLocationPlaceholderLabel = styled.div `
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  margin-top: 1rem;
  text-align: center;
`;
